// extracted by mini-css-extract-plugin
export var mainWrapper = "favoriteIcon-module--mainWrapper--b5248";
export var nbWish = "favoriteIcon-module--nbWish--ed107";